export default __webpack_public_path__ + "static/media/BabyPicture.80d2d2cb.jpg";